<template>
    <div>
        <v-modal ref="modalFastLogin2" id="modalFastLogin2" titulo="Confirmação de Acesso">
            <div slot="body">
                <p><small>Informe o código enviado no {{retorno.tipo}} {{retorno.email_telefone}}</small></p>
            
                <div class="clearfix mb-4"></div>
                <div v-if="fast.error" class="alert fade show alert-danger col-10">
                    <small v-html="fast.error"></small>
                </div>
                <div class="row">
                    <v-input-text v-model="codigo" label="<b>Digite o código recebido</b>" fieldsetClasse="col-10 mb-4" mask="######"></v-input-text>
                </div>

                <div v-if="retorno.tipo == 'email'">
                    <div  style="margin-left:5px;"><a  href="#"  @click="enviarCodigo('sms')"> Receber no meu celular</a></div>
                </div>

                <div v-if="retorno.tipo == 'sms'">
                    <div ><a  href="#"  @click="enviarCodigo('email');">Receber no meu e-mail</a></div>
                </div><br><br>
            </div>    
            <div slot="buttons">
                <v-button label="Confirmar" @click="autenticarFast"></v-button>
            </div>
        </v-modal>

        
        <p v-if="labelView" class="valor text-uppercase"></p>
        <form action="" class="row">
            <v-input-text label="Informe seu CPF"  v-model="fast.cpf"   mask="###.###.###-##"></v-input-text>
            <div class="w-100 mb-4"></div>
            <!--<v-input-select label="Enviar código por" v-model="fast.tipo" :options="tiposFast" :searchable="false"></v-input-select>-->

            <div class="col">
                <div class="row">
                    <div class="col col-md-6"><a  href="#"  @click="enviarCodigo('email');">Receber no meu e-mail</a></div>
                    <div class="col col-md-6"><a  href="#"  @click="enviarCodigo('sms')"> Receber no meu celular</a></div>
                </div>
            </div>
            <div class="w-100" style="margin-top:60px;"></div>
           
        </form>  
    </div>
</template>

<script>
    export default {
        props: {
            serial: {
                type: String,
                required: false,
            },
            labelView: {
                type: Boolean,
                default: true,
            },
            esqueciMinhaSenha: {
                type: Number,
                default: 0,
            },
        },
        data() {
            return {
                codigo: null,
                labelEmail: "email",
                loginFast: {
                    id_usuario: null,
                    codigo: null,
                    serial: null,
                    grant_type: "codigo_acesso",
                    checa_papel: 1,
                    esqueciMinhaSenha: this.esqueciMinhaSenha,
                },
                fast: {
                    cpf: null,
                    tipo: null,
                    error: null,
                },
                tiposFast: [
                    {
                        value: 'sms',
                        label: 'SMS',
                    },
                    {
                        value: 'email',
                        label: 'E-mail',
                    },
                ],
                retorno: {
                    labelTipo: null,
                    mascarado: null,
                    email_telefone: null,
                    tipo: null
                },
            }
        },
        methods: {
            enviarCodigo(tipo) {
                this.fast.esqueci_senha = this.esqueciMinhaSenha
                this.fast.error = null
                this.fast.tipo = tipo
                this.$resources.CodigoAcesso.post('', this.fast).then((response) => {
                    let dados = response.data.data
                    let mascarado = ''
                    let label = ''
                    if(dados.tipo == "sms"){
                        label = "telefone celular"
                        let hifenPosition = dados.telefone.search('-')
                        let endPrefixe = dados.telefone.slice(0,1) == "(" ? 4 : 2
                        mascarado += dados.telefone.slice(0, endPrefixe) +  _.repeat('*',4)
                        mascarado += hifenPosition > -1 ? dados.telefone.slice(hifenPosition) : '-' + dados.telefone.slice(-4)
                    }
                    else if(dados.tipo == "email"){
                        label = "endereço de e-mail"
                        let arrobaPosition = dados.email.search('@')
                        mascarado = dados.email.slice(0,2) +  _.repeat('*',4) + dados.email.slice(arrobaPosition)
                    }

                    this.loginFast.id_usuario = dados.fk_id_usuario
                    this.retorno.labelTipo = label
                    this.retorno.mascarado = mascarado

                    let email = dados.email.split('@')
                    let telefone = dados.telefone
                    let descricaoEmail = ""
                    let telefoneOculto = ""

                    for (var i = 0; i < email[0].length; i++) {
                        if(i == 0) {
                            descricaoEmail += email[0].charAt(i)
                        }  else {
                            descricaoEmail += "*"
                        }   
                    }
                    for (var i = 0; i < telefone.length; i++) {
                        if(i == 0 || i == 1 || i == 7 || i == 8 || i == 9 || i ==10) {
                            telefoneOculto += telefone.charAt(i)
                        }  else {
                            telefoneOculto += "*"
                        }   
                    }
                    email = descricaoEmail +"@"+email[1]
                    this.retorno.tipo = dados.tipo
                    this.retorno.email_telefone =  dados.tipo == 'email' ? email : telefoneOculto;

                    this.$refs.modalFastLogin2.show()
                    localStorage.setItem('loginFast',JSON.stringify(this.loginFast))
                }).catch((error) => {
                    this.rotinasDeErros(error)
                })
            },
            rotinasDeErros(error) {
                if(error.response && error.response.data && error.response.data.message) {
                    alert(error.response.data.message)
                    this.$root.setAlert(error.response.data.message,'danger')
                    return true
                } if(error.response && error.response.data && error.response.data.errors){
                    if(error.response.data.errors.expanded) {
                        alert(error.response.data.errors.expanded)
                        this.$root.setAlert(error.response.data.errors.expanded,'danger')
                        return true
                    }
                }
                this.$root.setAlert('Ocorreu um erro na solicitação','danger') 
            },
            autenticarFast(){
                this.loginFast = JSON.parse(localStorage.getItem('loginFast'))
                localStorage.clear()
                this.fast.error = null
                this.loginFast.serial = this.serial
                this.loginFast.codigo = this.codigo
                localStorage.setItem('loginFast',JSON.stringify(this.loginFast))
//                console.dir(this.loginFast)
                this.$resources.OAuth.post('/', this.loginFast).then((response) => {
                localStorage.clear()
                this.$refs.modalFastLogin2.close()
                this.$emit('login', response.data.data)
                }).catch((error) => {
                    if(error.response && error.response.data){
                        this.fast.error = error.response.data.message
                    }
                    else{
                        this.fast.error = 'Ocorreu um erro na solicitação'
                    }
                })
            },
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/Autenticacao/FastLoginModal.vue